import { RangeHorizon } from '@toggle/chart';
import { ExploreSingleInsight } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { BaseErrorView } from '~/components/base-error-view/BaseErrorView';
import { InsightsList } from '~/components/insights-group/insights-list/InsightsList';
import { IconConfig } from '~/views/insights/components/insights-full-drawer/InsightsFullDrawer';

import styles from './InsightsGroup.module.scss';

export interface InsightsGroupProps {
  horizon: RangeHorizon;
  activeInsightId: string;
  selectedInsights: ExploreSingleInsight[];
  isError: boolean;
  isInsightsLoading: boolean;
  handleSetActiveInsightId: (insightId: string) => void;
  handleSetIconConfig?: (config: IconConfig) => void;
}

export const InsightsGroup = ({
  horizon,
  activeInsightId = '',
  selectedInsights,
  isError,
  isInsightsLoading,
  handleSetActiveInsightId,
  handleSetIconConfig,
}: InsightsGroupProps) => {
  const { t } = useTranslation(['insights']);

  const renderCards = () => {
    if (isError) {
      return <BaseErrorView className={styles.styledBaseErrorView} />;
    }

    return (
      <InsightsList
        activeInsightId={activeInsightId}
        selectedInsights={selectedInsights}
        isInsightsLoading={isInsightsLoading}
        handleSetActiveInsightId={handleSetActiveInsightId}
        handleSetIconConfig={handleSetIconConfig}
      />
    );
  };

  return (
    <div className={styles.insightsGroupRoot}>
      <div className={styles.header}>
        <h4 className={styles.title}>
          {t('insights:insightsGroup.title', {
            horizon: t(`insights:insightsGroup.${horizon}`),
          })}
        </h4>
        <span className={styles.text}>
          {t('insights:insightsGroup.mostRecentFirst')}
        </span>
      </div>
      {renderCards()}
    </div>
  );
};
